let list;
let selectedEmailsData = [];
// let API_BASE_URL = 'https://aif.hcshub.in/aif-api/ai-api';
let API_BASE_URL = 'https://aif.hcshub.in/aif-api/ai-api';
Office.onReady(async (info) => {
  if (info.host === Office.HostType.Outlook) {
    document.getElementById("sideload-msg").style.display = "none";
    document.getElementById("app-body").style.display = "flex";

    list = document.getElementById("selected-items");

    // Show loading while authenticating
    showLoading(true);
    showStatus('Verifying user authentication...', 'info');

    // Authenticate user
    const authResult = await authenticateUser();


    if (!authResult.success) {
      showLoading(false);
      showStatus(authResult.message || 'User not exist in AIF', 'error');
      // Disable buttons if authentication fails
      document.getElementById("refresh-btn").disabled = true;
      document.getElementById("send-to-aif-btn").disabled = true;
      return;
    }

    showLoading(false);
    showStatus('Authentication successful!', 'success');
    let userId = authResult.data.data.id;
    // Button event handlers
    document.getElementById("refresh-btn").onclick = refreshEmails;
    document.getElementById("send-to-aif-btn").onclick = () => sendAllToAIF(userId);

    // Register event handler for selected items
    // Office.context.mailbox.addHandlerAsync(
    //   Office.EventType.SelectedItemsChanged, 
    //   refreshEmails, 
    //   (asyncResult) => {
    //     if (asyncResult.status === Office.AsyncResultStatus.Failed) {
    //       showStatus(asyncResult.error.message, 'error');
    //       return;
    //     }
    //     console.log("Event handler added.");
    //   }
    // );

    // Initial load
    // refreshEmails();
  }
});

// Authenticate user with AIF
async function authenticateUser() {
  try {
    const userProfile = Office.context.mailbox.userProfile;
    const email = await encryptEmailId(userProfile.emailAddress);

    const apiUrl = `${API_BASE_URL}/emails/auth`;

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: email,
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      return {
        success: false,
        message: errorData.message || 'User not exist in AIF'
      };
    }
    const { data } = await response.json();


    if (!data.success) {
      return {
        success: false,
        message: data.message || 'User not exist in AIF'
      };
    }

    return {
      success: true,
      message: 'User authenticated successfully',
      data: data
    };
  } catch (error) {

    return {
      success: false,
      message: 'Failed to authenticate user: ' + error.message
    };
  }
}

// Refresh the email list
async function refreshEmails() {
  clearList(list);
  selectedEmailsData = [];
  updateEmailCount(0);
  showStatus('Refreshing emails...', 'info');

  Office.context.mailbox.getSelectedItemsAsync((asyncResult) => {
    if (asyncResult.status === Office.AsyncResultStatus.Failed) {
      showStatus(asyncResult.error.message, 'error');
      return;
    }

    const selectedItems = asyncResult.value;
    if (selectedItems.length === 0) {
      showStatus('No emails selected', 'info');
      return;
    }
    if (selectedItems.length > 10) {
      showStatus('Maximum 10 emails allowed.', 'error');
      return;
    }
    getItemInfo(selectedItems);
  });
}

// Get detailed information for each email
async function getItemInfo(selectedItems) {
  // Use a Set to track unique item IDs and prevent duplicates
  const processedItemIds = new Set();

  for (const item of selectedItems) {
    // Skip if we've already processed this item
    if (processedItemIds.has(item.itemId)) {
      console.log("Skipping duplicate item:", item.itemId);
      continue;
    }

    processedItemIds.add(item.itemId);
    console.log(item, "itemitemitemitemitem")

    const emailData = {
      itemId: item.itemId,
      messageId: item.itemId,
      subject: item.subject,
      from: null,
      to: null,
      cc: null,
      fromName: null,
      receivedDateTime: null,
      body: null,
      internetMessageId: item.internetMessageId,
      conversationId: item.conversationId,
      attachments: [],
      hasAttachments: false,
      attachmentCount: 0
    };

    if (Office.context.requirements.isSetSupported("Mailbox", "1.15")) {
      await getDetailedEmailInfo(emailData);
    } else {
      addEmailToList(emailData);
      selectedEmailsData.push(emailData);
    }
  }

  updateEmailCount(selectedEmailsData.length);
  showStatus(`${selectedEmailsData.length} email(s) loaded`, 'info');
}
// Get attachment content
function getAttachmentContent(item, attachmentId) {
  return new Promise((resolve, reject) => {
    item.getAttachmentContentAsync(attachmentId, (result) => {
      if (result.status === Office.AsyncResultStatus.Failed) {
        reject(result.error.message);
        return;
      }

      resolve(result.value);
    });
  });
}


// Get detailed email information including body
async function getDetailedEmailInfo(emailData) {
  return new Promise((resolve) => {
    Office.context.mailbox.loadItemByIdAsync(emailData.itemId, async (result) => {
      if (result.status === Office.AsyncResultStatus.Failed) {
        console.log(result.error.message);
        resolve();
        return;
      }

      const loadedItem = result.value;

      if (!loadedItem.from || !loadedItem.from.emailAddress) {
        console.log("Skipping invalid mail item:", emailData.itemId);
        loadedItem.unloadAsync();
        resolve();
        return;
      }
      console.log(loadedItem.from, "emailData.itemId")
      // Handle from field - might be an object or undefined
      emailData.from = loadedItem.from?.emailAddress || '';
      emailData.fromName = loadedItem.from?.displayName || '';
      // Handle to field - ensure it's an array before mapping
      if (Array.isArray(loadedItem.to)) {
        emailData.to = loadedItem.to.map(recipient => recipient.emailAddress);
      } else if (loadedItem.to) {
        emailData.to = [loadedItem.to.emailAddress];
      } else {
        emailData.to = [];
      }

      // Handle cc field - ensure it's an array before mapping
      if (Array.isArray(loadedItem.cc)) {
        emailData.cc = loadedItem.cc.map(recipient => recipient.emailAddress);
      } else if (loadedItem.cc) {
        emailData.cc = [loadedItem.cc.emailAddress];
      } else {
        emailData.cc = [];
      }

      emailData.receivedDateTime = loadedItem.dateTimeCreated;

      // Get attachments information
      if (loadedItem.attachments && loadedItem.attachments.length > 0) {
        emailData.hasAttachments = true;
        emailData.attachmentCount = loadedItem.attachments.length;

        for (const att of loadedItem.attachments) {
          if (att.attachmentType === "file") {
            try {
              const content = await getAttachmentContent(loadedItem, att.id);

              emailData.attachments.push({
                id: att.id,
                name: att.name,
                size: att.size,
                contentType: att.contentType,
                attachmentType: att.attachmentType,
                isInline: att.isInline || false,
                contentBytes: content.content // Base64 content
              });
            } catch (err) {
              console.error("Attachment error:", err);
            }
          }
        }
      }

      // Get email body (both HTML and Text for better formatting preservation)
      loadedItem.body.getAsync(Office.CoercionType.Html, (htmlResult) => {
        if (htmlResult.status === Office.AsyncResultStatus.Succeeded) {
          emailData.bodyHtml = htmlResult.value;
        }

        // Also get plain text version
        loadedItem.body.getAsync(Office.CoercionType.Text, (textResult) => {
          if (textResult.status === Office.AsyncResultStatus.Succeeded) {
            emailData.body = textResult.value;
          }

          addEmailToList(emailData);
          selectedEmailsData.push(emailData);

          loadedItem.unloadAsync((asyncResult) => {
            if (asyncResult.status === Office.AsyncResultStatus.Failed) {
              console.log(asyncResult.error.message);
            }
            resolve();
          });
        });
      });
    });
  });
}

/**
 * Send all emails to AIF API
 * 
 * Handles 12 different cases:
 * Case 1: All Selected Emails Were Already Sent
 * Case 2: Some Emails Were Already Sent and Some Were Sent Now
 * Case 3: Some Emails Were Already Sent and Some Failed
 * Case 4: Mixed Results (Already Sent, Sent Now, and Failed)
 * Case 5: All Emails Sent Successfully
 * Case 6: All Emails Are Too Large
 * Case 7: Some Emails Are Too Large and Some Were Sent
 * Case 8: No Internet Connection
 * Case 9: Authentication Failed
 * Case 10: AIF Server Error
 * Case 11: Some Emails Sent and Some Failed Due to Server Error
 * Case 12: AIF Service Temporarily Unavailable
 */
async function sendAllToAIF(userId) {
  if (selectedEmailsData.length === 0) {
    showStatus('No emails to send. Please select emails first.', 'error');
    return;
  }

  const sendBtn = document.getElementById("send-to-aif-btn");
  const refreshBtn = document.getElementById("refresh-btn");

  // Disable buttons and show loading
  sendBtn.disabled = true;
  refreshBtn.disabled = true;
  showLoading(true);
  showStatus(`Sending ${selectedEmailsData.length} email(s) to AIF...`, 'info');

  try {
    // Check internet connectivity
    if (!navigator.onLine) {
      showStatus('No internet connection. Please check your network and try again.', 'error');
      sendBtn.disabled = false;
      refreshBtn.disabled = false;
      showLoading(false);
      return;
    }

    // Call your API endpoint here
    const response = await sendEmailsToAPI(selectedEmailsData, userId);

    if (response.success) {
      // Extract response data
      const responseData = response.data?.data?.data;
      const newlySaved = responseData?.newlySaved || 0;
      const alreadyExists = responseData?.alreadyExists || 0;
      const failed = responseData?.failed || 0;
      const tooLarge = responseData?.tooLarge || 0;
      const totalProcessed = responseData?.totalProcessed || selectedEmailsData.length;
      const totalSelected = selectedEmailsData.length;

      // Build dynamic message based on all cases
      const message = buildEmailStatusMessage(totalSelected, newlySaved, alreadyExists, failed, tooLarge);

      showStatus(message.text, message.type);
    } else {
      // Handle specific error responses
      handleErrorResponse(response);
    }
  } catch (error) {
    // Handle network and unexpected errors
    if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
      showStatus('No internet connection. Please check your network and try again.', 'error');
    } else if (error.message.includes('Authentication') || error.message.includes('Unauthorized')) {
      showStatus('Your account authorization failed.', 'error');
    } else {
      showStatus('Something went wrong. Please try again later.', 'error');
    }
    console.error('Error sending emails:', error);
  } finally {
    sendBtn.disabled = false;
    refreshBtn.disabled = false;
    showLoading(false);
  }
}

// Build comprehensive email status message
function buildEmailStatusMessage(totalSelected, newlySaved, alreadyExists, failed, tooLarge) {
  const parts = [];
  let messageType = 'success';

  // Case 1: All emails already sent
  if (alreadyExists === totalSelected && newlySaved === 0 && failed === 0 && tooLarge === 0) {
    return {
      text: 'All the selected emails were already sent to AIF.',
      type: 'info'
    };
  }

  // Case 5: All emails sent successfully
  if (newlySaved === totalSelected && alreadyExists === 0 && failed === 0 && tooLarge === 0) {
    return {
      text: 'All selected emails have been sent successfully.',
      type: 'success'
    };
  }

  // Case 6: All emails are too large
  if (tooLarge === totalSelected && newlySaved === 0 && alreadyExists === 0 && failed === 0) {
    return {
      text: 'The selected emails are too large to be sent.',
      type: 'error'
    };
  }

  // Build message parts for mixed cases
  if (alreadyExists > 0) {
    parts.push(`${alreadyExists} email${alreadyExists > 1 ? 's were' : ' was'} already sent earlier`);
  }

  if (newlySaved > 0) {
    parts.push(`${newlySaved} email${newlySaved > 1 ? 's have' : ' has'} been sent successfully`);
  }

  if (tooLarge > 0) {
    parts.push(`${tooLarge} email${tooLarge > 1 ? 's are' : ' is'} too large to be sent`);
    messageType = failed > 0 || (newlySaved === 0 && alreadyExists === 0) ? 'error' : 'warning';
  }

  if (failed > 0) {
    if (parts.length === 0 && failed === totalSelected) {
      // All failed
      parts.push(`All ${failed} email${failed > 1 ? 's' : ''} could not be sent`);
    } else {
      parts.push(`${failed} email${failed > 1 ? 's' : ''} could not be sent`);
    }
    messageType = 'error';
  }

  // Combine parts with proper grammar
  let message = '';
  if (parts.length === 1) {
    message = parts[0] + '.';
  } else if (parts.length === 2) {
    message = parts.join(', and ') + '.';
  } else if (parts.length >= 3) {
    const lastPart = parts.pop();
    message = parts.join(', ') + ', and ' + lastPart + '.';
  }

  // Capitalize first letter
  message = message.charAt(0).toUpperCase() + message.slice(1);

  return {
    text: message,
    type: messageType
  };
}

// Handle error responses from API
function handleErrorResponse(response) {
  const statusCode = response.statusCode || response.status;
  const errorMessage = response.message || '';

  // Case 9: Authentication Failed (401, 403)
  if (statusCode === 401 || statusCode === 403 || errorMessage.includes('authentication') || errorMessage.includes('authorization')) {
    showStatus('Your account authorization failed.', 'error');
    return;
  }

  // Case 12: Service Temporarily Unavailable (503)
  if (statusCode === 503 || errorMessage.includes('unavailable') || errorMessage.includes('maintenance')) {
    showStatus('The service is temporarily unavailable. Please try again later.', 'error');
    return;
  }

  // Case 10: Server Error (500, 502, 504)
  if (statusCode >= 500 && statusCode < 600) {
    showStatus('Something went wrong on our side. Please try again later.', 'error');
    return;
  }

  // Default error message
  showStatus(errorMessage || 'Failed to send emails. Please try again.', 'error');
}

// API call function
async function sendEmailsToAPI(emails, userId) {
  const apiUrl = `${API_BASE_URL}/emails/store`;

  try {
    // Separate emails data from attachments
    const emailsWithoutAttachmentContent = emails.map(email => {
      const emailCopy = { ...email };
      // Keep attachment metadata but remove content
      if (emailCopy.attachments && emailCopy.attachments.length > 0) {
        emailCopy.attachmentMetadata = emailCopy.attachments.map(att => ({
          id: att.id,
          name: att.name,
          size: att.size,
          contentType: att.contentType,
          isInline: att.isInline
        }));
        delete emailCopy.attachments;
      }
      return emailCopy;
    });

    // First, send email metadata
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        emails: emailsWithoutAttachmentContent.map(email => ({
          itemId: email.itemId,
          subject: email.subject,
          from: email.from,
          to: email.to,
          cc: email.cc,
          fromName: email.fromName || '',
          receivedDateTime: email.receivedDateTime,
          body: email.body,
          bodyHtml: email.bodyHtml || null,
          internetMessageId: email.internetMessageId,
          conversationId: email.conversationId,
          hasAttachments: email.hasAttachments || false,
          attachmentCount: email.attachmentCount || 0,
          attachmentMetadata: email.attachmentMetadata || [],
          timestamp: new Date().toISOString()
        })),
        source: 'Outlook',
        totalCount: emails.length,
        userId: userId
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      return {
        success: false,
        status: response.status,
        statusCode: response.status,
        message: errorData.message || `HTTP error! status: ${response.status}`,
        data: errorData
      };
    }

    const data = await response.json();

    // Now send attachments separately if any exist
    const emailsWithAttachments = emails.filter(e => e.attachments && e.attachments.length > 0);
    console.log("emailsWithAttachments", emailsWithAttachments, data.data.data.emailIds)
    if (emailsWithAttachments.length > 0 && data.data && data.data.data.emailIds) {
      await sendAttachmentsSeparately(emailsWithAttachments, data.data.data.emailIds, userId);
    }

    return {
      success: true,
      data: data,
      message: data.message || 'Emails stored successfully'
    };
  } catch (error) {
    console.error('API Error:', error);

    // Return detailed error information
    return {
      success: false,
      message: error.message || 'Failed to send emails',
      error: error.name,
      statusCode: error.status || 0
    };
  }
}

// Send attachments separately to avoid payload size limit
async function sendAttachmentsSeparately(emails, emailIds, userId) {
  console.log("emails, emailIds, userId", emails, emailIds, userId)
  const uploadUrl = `${API_BASE_URL}/emails/upload-attachments`;

  for (let i = 0; i < emails.length; i++) {
    const email = emails[i];

    if (!email.attachments || email.attachments.length === 0) {
      continue;
    }

    // Send each attachment individually to avoid size issues
    for (const attachment of email.attachments) {
      try {
        const formData = new FormData();

        // Convert base64 to blob
        const byteCharacters = atob(attachment.contentBytes);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: attachment.contentType || 'application/octet-stream' });

        formData.append('file', blob, attachment.name);
        formData.append('messageId', email.itemId); // Send message_id instead of email_id
        formData.append('userId', userId);
        formData.append('attachmentId', attachment.id);
        formData.append('isInline', attachment.isInline ? '1' : '0');
        formData.append('contentType', attachment.contentType || '');
        formData.append('fileSize', attachment.size || blob.size);

        const uploadResponse = await fetch(uploadUrl, {
          method: 'POST',
          body: formData
        });

        if (!uploadResponse.ok) {
          console.error(`Failed to upload attachment: ${attachment.name}`);
        } else {
          console.log(`Successfully uploaded attachment: ${attachment.name}`);
        }
      } catch (error) {
        console.error(`Error uploading attachment ${attachment.name}:`, error);
      }
    }
  }
}

// UI Helper Functions
function clearList(list) {
  while (list.firstChild) {
    list.removeChild(list.firstChild);
  }
}

function addEmailToList(emailData) {
  const listItem = document.createElement("li");

  const subjectElement = document.createElement("strong");
  subjectElement.textContent = emailData.subject || '(No Subject)';

  const senderElement = document.createElement("div");
  senderElement.className = "sender";
  senderElement.textContent = emailData.from ? `From: ${emailData.from}` : 'Sender information unavailable';

  listItem.appendChild(subjectElement);
  listItem.appendChild(senderElement);
  list.appendChild(listItem);
}

function updateEmailCount(count) {
  document.getElementById("email-count").textContent = count;
}

function showStatus(message, type) {
  const statusEl = document.getElementById("status-message");
  statusEl.textContent = message;
  statusEl.className = `status-message ${type}`;
  statusEl.style.display = 'block';
}

function showLoading(show) {
  document.getElementById("loading-overlay").style.display = show ? 'flex' : 'none';
}

// Frontend Encryption (Browser Compatible)
async function encryptEmailId(emailId) {
  const secretHex =
    '9b7e6f9c1a4e8b0c9d7a6f5e4c3b2a1d9b7e6f9c1a4e8b0c9d7a6f5e4c3b2a1d';

  const iv = crypto.getRandomValues(new Uint8Array(12)); // 12 bytes
  const keyBytes = Uint8Array.from(
    secretHex.match(/.{2}/g).map(b => parseInt(b, 16))
  );

  const key = await crypto.subtle.importKey(
    "raw",
    keyBytes,
    "AES-GCM",
    false,
    ["encrypt"]
  );

  const encoded = new TextEncoder().encode(emailId);

  const encryptedBuffer = await crypto.subtle.encrypt({ name: "AES-GCM", iv }, key, encoded);

  // encryptedBuffer contains cipher + authTag (last 16 bytes)
  const encryptedArray = new Uint8Array(encryptedBuffer);
  const authTag = encryptedArray.slice(encryptedArray.length - 16);
  const cipherText = encryptedArray.slice(0, encryptedArray.length - 16);

  // Final payload = iv + cipher + authTag
  const finalPayload = new Uint8Array([
    ...iv,
    ...cipherText,
    ...authTag
  ]);

  return btoa(String.fromCharCode(...finalPayload));
}

